import { render, staticRenderFns } from "./CommentPlotTable.vue?vue&type=template&id=6fb82dc4&scoped=true&"
import script from "./CommentPlotTable.vue?vue&type=script&lang=js&"
export * from "./CommentPlotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb82dc4",
  null
  
)

export default component.exports